import apiClient from "@/app/api/client";
import type { AuthData, LoginRequest, LoginResponse, MeResponse, User } from "../types";

export const authService = {
	async login(data: LoginRequest): Promise<AuthData> {
		const response = await apiClient.post<LoginResponse>("/auth/login", data);
		return response.data.data;
	},

	/** Refresh cookie'ga tayanadi — body yubormaydi. */
	async logout(): Promise<void> {
		await apiClient.post("/auth/logout", {});
	},

	async logoutAll(): Promise<void> {
		await apiClient.post("/auth/logout-all", {});
	},

	async getMe(): Promise<User> {
		const response = await apiClient.get<MeResponse>("/auth/me");
		return response.data.data;
	},
};
